export type AuthAppOrigins = {
  publicAppUrl: string;
  studioAppUrl: string;
};

export function normalizeAppOrigin(url: string): string {
  return url.trim().replace(/\/$/, '');
}

export function isAllowedPublicReturnPath(path: string): boolean {
  return path.startsWith('/') && !path.startsWith('//');
}

export function isAllowedAuthReturnUrl(candidate: string, origins: AuthAppOrigins): boolean {
  try {
    const origin = new URL(candidate).origin;
    const allowed = [
      new URL(normalizeAppOrigin(origins.publicAppUrl)).origin,
      new URL(normalizeAppOrigin(origins.studioAppUrl)).origin,
    ];
    return allowed.includes(origin);
  } catch {
    return false;
  }
}

export function buildPublicLoginUrl(publicAppUrl: string, returnTo?: string | null): string {
  const url = new URL('/login', `${normalizeAppOrigin(publicAppUrl)}/`);
  if (returnTo?.trim()) {
    url.searchParams.set('returnTo', returnTo.trim());
  }
  return url.toString();
}

export function resolvePostLoginDestination(
  returnTo: string | null | undefined,
  origins: AuthAppOrigins,
  fallbackPublicPath: string,
): string {
  const fallback = isAllowedPublicReturnPath(fallbackPublicPath)
    ? fallbackPublicPath
    : '/feed';
  if (!returnTo?.trim()) return fallback;

  const value = returnTo.trim();
  if (isAllowedPublicReturnPath(value)) return value;
  if (isAllowedAuthReturnUrl(value, origins)) return value;
  return fallback;
}

export function isExternalAuthDestination(destination: string): boolean {
  return /^https?:\/\//i.test(destination);
}
